import { useMutation } from 'react-query'

import { scanToEarnService } from 'src/services/scan-to-earn.service'
import { IScanToEarnFindImpactsDto } from 'src/types'

const useFindImpacts = () => {
  return useMutation((dto: IScanToEarnFindImpactsDto) => scanToEarnService.findImpacts(dto), {})
}

export { useFindImpacts }
